'use strict';

var _ = require('lodash');
window.$ = window.jQuery = require('jquery');
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

require('materialize-css');
require('slick-carousel');
window.Swal=require('sweetalert');
require('./percircle');
require('./product');
//require('./cotizar');
require('./blog');
require('./newsletter');
require('./contact');

let lazyImages = [...document.querySelectorAll('.lazy')];
let instagramFt=true,percentFt=true;

function lazyLoad() {
    lazyImages.forEach(image => {
        if(elementVisible(image)){
            image.src = image.dataset.src;
            image.onload = () => image.classList.add('loaded');
        }
    });
    if(elementVisible($('.sectionPercent h2')[0])){
        if(percentFt) {
            percentFt=false;
            $("#percent_1,.percent_1").percircle();
        }
    }
    if($('.sectionInstagram').length>=1){
        if(elementVisible($('.sectionInstagram')[0])){
            if(instagramFt){
                instagramFt=false;
                var url_instagram = '';
                var link_instagram = '';
                var URL_API_INSTAGRAM = "https://v1.nocodeapi.com/gutand/instagram/wEzkCYczaeDJZDPb";
                $.getJSON(URL_API_INSTAGRAM, function(data) {
                    $(".js-instagram").each(function(key, elm) {
                        if(data.data[key].media_type == 'VIDEO'){
                            url_instagram = data.data[key].thumbnail_url;
                        }else{
                            url_instagram = data.data[key].media_url;
                        }
                        link_instagram = data.data[key].permalink;
                        $(elm)
                            .attr({
                                "data-url": url_instagram
                            })
                            .click(function() {
                                window.open(link_instagram, "_blank");
                            });
                        $(elm.querySelector("img")).attr({
                            src: url_instagram
                        });
                    });
                })
            }
        }
    }

}
window.addEventListener('scroll', _.throttle(lazyLoad, 16));
window.addEventListener('resize', _.throttle(lazyLoad, 16));
if(window.location.pathname == '/'){
    document.getElementById('sliderRowBlog').addEventListener('scroll', _.throttle(lazyLoad, 16));
}

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
            lazyLoad();
        },0);
    }
    window.load = cargar();
    $('.modal').modal({
        dismissible: false,
    });
    $('.sidenav').sidenav({
        edge: 'right',
    });
});

$('.close-menu').click(function () {
    $('.sidenav').sidenav('close');
});


$('.clickAbout').click(function () {
    $('html, body').animate({
        scrollTop: $('#about').offset().top - 100
    }, 1000);
});
$('.clickProducts').click(function () {
    $('html, body').animate({
        scrollTop: $('#products').offset().top - 100
    }, 1000);
    setTimeout(function () {
        $('html, body').animate({
            scrollTop: $('#products').offset().top - 100
        }, 500);
    },1100);
});
$('.clickBlog').click(function () {
    $('html, body').animate({
        scrollTop: $('#blog').offset().top - 100
    }, 1000);
    setTimeout(function () {
        $('html, body').animate({
            scrollTop: $('#blog').offset().top - 100
        }, 500);
    },1100);
});
$('.clickClients').click(function () {
    $('html, body').animate({
        scrollTop: $('#clients').offset().top - 100
    }, 1000);
    setTimeout(function () {
        $('html, body').animate({
            scrollTop: $('#clients').offset().top - 100
        }, 500);
    },1100);
});
$('.clickContact').click(function () {
    $('html, body').animate({
        scrollTop: $('#contact').offset().top - 100
    }, 1000);
    setTimeout(function () {
        $('html, body').animate({
            scrollTop: $('#contact').offset().top - 100
        }, 500);
    },1100);
});


$(document).ready(function () {
    $('#sliderBanner').slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        cssEase: 'easeOutElastic',
        fade: true,
        swipe: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
    });
    $('#sliderProducts').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,  //habian 5
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        swipe: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        prevArrow: $('.sectionProductsDest .arrowSlider .arrowLeft'),
        nextArrow: $('.sectionProductsDest .arrowSlider .arrowRight'),
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });
    $('#sliderClients').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        swipe: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        cssEase: 'easeOutElastic',
        fade: true,
        lazyLoad: 'ondemand',
        prevArrow: $('.sectionHomeClients .arrows .arrowLeft'),
        nextArrow: $('.sectionHomeClients .arrows .arrowRight'),
    });

});


function elementVisible(element){
    var visible = true;
    var windowTop = $(document).scrollTop();
    var windowBottom = windowTop + window.innerHeight;
    var elementPositionTop =  $(element).offset().top;
    var elementPositionBottom = elementPositionTop + $(element).height();
    if (elementPositionTop >= windowBottom || elementPositionBottom <= windowTop) {
        visible = false;
    }
    return visible;
}

$('.modalBlog').click(function (e) {
    if($(e.target).parents('.rowOne').length == 0)
        $('.modal').modal('close');
});

/*
$('.modalCotizar').click(function (e) {
    if($(e.target).parents('.rowOne').length == 0)
        $('.modal').modal('close');
});
*/

$('.sectionBlogHome .element').click(function (e) {
    $('.modalBlog').modal('open');
});




setInterval(function () {
    if ($(window).width() > 600) {
        $('.modalBlog .banner').css('height',$('.modalBlog .rowOne').css('height'));
        $('.modalCotizar .banner').css('height',$('.modalCotizar .rowOne').css('height'));
        $('.modalBlog .description').css('height',$('.modalBlog .rowOne').css('height'));
        $('.modalCotizar .description').css('height',$('.modalCotizar .rowOne').css('height'));
        $('.containerMap').css('height', $('footer .rowOne').css('height'));
    }
},100);

$('.sectionProductInfo .image-change').click(function(){
    // var previuwSRC = $('.sectionProductInfo .image-big').attr('src');
    $('.sectionProductInfo .image-big').attr('src',($('.image-change'+this.id).attr('data-src')));
    //$('.image-change'+this.id).attr('data-src',previuwSRC);
    //$('.image-change'+this.id).attr('src',previuwSRC);
});
